import ParameterizedErrorPage from "./ParameterizedErrorPage"

export default function ErrorPage({ errorMsg }: { errorMsg?: string }) {
  return <ParameterizedErrorPage errorMsg={errorMsg} />
}
